import React from "react";
import { Carousel } from "react-bootstrap";
import carousel1 from "../images/carousel-img-1.png";
import carousel2 from "../images/carousel-img-2.png";
import google from "../images/google-play.png";
import apple from "../images/apple-store.png";


const Hero = () => {
  return (
    <Carousel data-bs-theme="dark" className="carousel-container">
      <Carousel.Item>
        <img src={carousel1} alt="Pet" className="img-fluid" />
        <Carousel.Caption>
          <h1>Meet Pets in Your Area!</h1>
          <p>
            Life's Better with Pets— <br />
            And There's One Near You!
          </p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img src={carousel2} alt="Pet" className="img-fluid" />
        <Carousel.Caption>
          <h1>
            Your New Best <br />
            Friend is Waiting
          </h1>
          <p>
            <a href="#">Explore Pets at PetCrew</a>
          </p>
          <div className="download-apple-section">
            <a href="https://play.google.com/store/apps/details?id=com.petcrew"><img src={google}/></a>
            <a href="https://apps.apple.com/in/app/petcrew-your-perfect-pup/id6740723086"><img src={apple}/></a>
          </div>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
}

export default Hero;
